import type React from 'react';

import type { CellContext, HeaderContext, RowData } from '@tanstack/react-table';

import type { TBuildTableViewCell } from './buildTableViewCell';

type TableCtx<TData extends RowData, TValue = unknown> =
  CellContext<TData, TValue> | HeaderContext<TData, TValue>;

function renderHeader<TData extends RowData, TValue>(
  renderer: (ctx: TableCtx<TData, TValue>) => TBuildTableViewCell,
  value: React.ReactNode = '',
) {
  return (header: HeaderContext<TData, TValue>): React.JSX.Element => renderer(header)(value);
}

function renderCell<TData extends RowData, TValue>(
  renderer: (ctx: TableCtx<TData, TValue>) => TBuildTableViewCell,
  wrap?: (ctx: CellContext<TData, TValue>) => React.ReactNode,
) {
  return (ctx: CellContext<TData, TValue>): React.JSX.Element => renderer(ctx)(
    wrap
      ? wrap(ctx)
      : ctx.getValue() as React.ReactNode,
  );
}

export type { TableCtx };
export { renderHeader, renderCell };
